import React, { useEffect } from "react";
import { bgImgFromData } from "../../lib/helpers";
import { Link } from "react-router-dom";

const BreadcrumbArea = ({ title, subtitle, desc }) => {
  useEffect(() => {
    bgImgFromData();
  }, []);

  return (
    <section
      className="breadcrumb-area breadcrumb-bg"
      data-background="/img/bg/breadcrumb_bg.jpg"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="breadcrumb-content">
              <h2 className="title">{title}</h2>

              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    {subtitle}
                  </li>
                </ol>
              </nav>

              {desc && <h3 className="mt-20" style={{ fontSize: 20, color: 'white', fontWeight: 200 }}>{desc}</h3>}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BreadcrumbArea;
